export const substances = {
  food: 'Alimento',
  medicine: 'Medicamento',
  others: 'Outros',
};

export function getName(value) {
  return substances[value];
}
